import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faHeart, faComment, faDownload, faPlay, faVideo } from '@fortawesome/free-solid-svg-icons';
import TagList from '../TagList/TagList';
import CardActions from '../CardActions/CardActions';
import { MediaFallback } from '../MediaFallback/MediaFallback';

const Stat = ({ icon, value }) => (
    <span className="inline-flex items-center gap-1.5 text-gray-500 dark:text-gray-400 text-sm">
        <FontAwesomeIcon icon={icon} className="text-brand-400" />
        {value}
    </span>
);

const formatDuration = (totalSeconds) => {
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${minutes}:${seconds < 10 ? '0' + seconds : seconds}`;
};

const VideoCardDetails = ({ video }) => {
    const { id, videos, user, views, likes, comments, downloads, duration, tags } = video;
    const preview = videos.medium || videos.small || videos.large || videos.tiny;
    const tagsSplit = tags.split(',');
    const [failed, setFailed] = useState(!preview?.url);

    return (
        <div className="group rounded-xl overflow-hidden shadow-e0 hover:shadow-e2 bg-white dark:bg-gray-800 border border-gray-100 dark:border-gray-700 transition-shadow duration-200">
            <div className="relative overflow-hidden h-56 bg-black">
                {failed ? (
                    <MediaFallback icon={faVideo} label={`Video by ${user}`} />
                ) : (
                    <video
                        src={preview.url}
                        poster={preview.thumbnail}
                        muted
                        loop
                        playsInline
                        preload="metadata"
                        onError={() => setFailed(true)}
                        onMouseEnter={(e) => e.currentTarget.play().catch(() => {})}
                        onMouseLeave={(e) => { e.currentTarget.pause(); e.currentTarget.currentTime = 0; }}
                        className="w-full h-full object-cover object-center transform group-hover:scale-105 transition-transform duration-300"
                    />
                )}
                {/* play hint (fades out on hover) */}
                {!failed && (
                    <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                        <span className="flex items-center justify-center h-12 w-12 rounded-full bg-black bg-opacity-50 text-white opacity-90 group-hover:opacity-0 transition-opacity duration-200">
                            <FontAwesomeIcon icon={faPlay} />
                        </span>
                    </div>
                )}
                <span className="absolute bottom-3 left-3 bg-black bg-opacity-70 text-white text-xs font-semibold px-2 py-1 rounded">
                    {formatDuration(duration)}
                </span>
                <CardActions
                    kind="video"
                    item={video}
                    downloadUrl={preview.url}
                    downloadFilename={`pixiy-video-${id}.mp4`}
                />
            </div>
            <div className="p-4">
                <div className="mb-3">
                    <h3 className="text-gray-900 dark:text-white text-lg font-bold capitalize truncate">
                        Video by {user}
                    </h3>
                </div>
                <div className="flex flex-wrap gap-x-4 gap-y-2 mb-3">
                    <Stat icon={faEye} value={views} />
                    <Stat icon={faHeart} value={likes} />
                    <Stat icon={faComment} value={comments} />
                    <Stat icon={faDownload} value={downloads} />
                </div>
                <TagList tags={tagsSplit} />
            </div>
        </div>
    );
};

export default VideoCardDetails;
